module.exports = __webpack_public_path__ + "64b94c7f73763871b541f9b4b0b2056d.svg";